import AuthClient, { InteractiveLoginError, TimeoutError, } from '@bridge/auth-js';
class PkceAuthClient {
    client = null;
    error = null;
    constructor() {
        const redirectUrl = window.location.origin;
        const scopes = ['bridge.signin', 'openid', 'enterprise.integration.web-app.command-center'];
        try {
            this.client = new AuthClient({
                // Environment and Client ID are retrieved via AWS secret in the webpack build process
                env: PKCE_CLIENT_ENV,
                clientId: PKCE_CLIENT_ID,
                redirectUrl,
                scopes,
            });
        }
        catch (error) {
            // Catch for any initialization errors, which can occur if there is a problem accessing PKCE_CLIENT_ENV
            // or PKCE_CLIENT_ID from AWS secrets manager
            // eslint-disable-next-line no-console
            console.error('Error initializing PKCE Auth Client: ', error);
        }
    }
    authenticate(onAuthenticated, onError) {
        if (this.client) {
            this.client
                .getAuth()
                .then((token) => {
                onAuthenticated(token);
            })
                .catch((error) => {
                if (error instanceof InteractiveLoginError) {
                    this.error = { type: 'LOGIN_REQUIRED', message: 'Interactive login required' };
                    // I am not sure if startInteractiveAuth is actually needed.
                    // Since these components will live on the bridge common landing page, I would assume that
                    // the user would already be logged in, and/or that bridge handles the interactive login flow.
                    // client.startInteractiveAuth();
                }
                else if (error instanceof TimeoutError) {
                    this.error = { type: 'TIMEOUT', message: 'Authentication timed out' };
                }
                else {
                    this.error = { type: 'UNKNOWN', message: error.message || 'Unknown error occurred' };
                }
                onError(this.error);
            });
        }
        else {
            // Client will be null if there was an initialization error
            onError({ type: 'UNKNOWN', message: 'Authentication client not initialized' });
        }
    }
}
export default new PkceAuthClient();
